import { PresentationEventTypes } from './event-types';
import type { IEventManager } from './event-manager';

export type ITransactionProvider = (action: () => void) => void;

export function createTransactionProvider(events: IEventManager): ITransactionProvider {
    return (action: () => void) => {
        events.emit(PresentationEventTypes.RequestBeginTransaction);
        try {
            action();
        } catch (err) {
            throw err;
        } finally {
            events.emit(PresentationEventTypes.RequestEndTransaction);
        }
    };
}
